import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get, isArray, isObject, size } from 'lodash'

import { LIST_SIZES, LIST_TYPES } from 'utils/constants/components/dropdown'
import { Text } from 'components/text/Text'

import styles from './DefaultTriggerRenderer.module.scss'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg'

const getValue = ({ isMultiSelect, multiSelectTitle, titleKey, value }) => {
  switch (true) {
    case isMultiSelect && size(value) === 1:
      return get(value, `[0].${titleKey}`)

    case isMultiSelect && size(value) > 1:
      return `${value.length} ${multiSelectTitle}`

    case !isMultiSelect && isArray(value):
      return get(value, `[0].${titleKey}`)

    case isObject(value):
      return get(value, titleKey)

    default:
      return value
  }
}

export const DefaultTriggerRenderer =
  ({
    error,
    isDisabled,
    isMultiSelect,
    isValid,
    multiSelectTitle = 'Items',
    placeholder,
    size,
    titleKey,
    type,
    value,
    triggerClassName,
  }) =>
  ({
    handlePopoverToggle, // eslint-disable-line
    isOpen, // eslint-disable-line
  }) => {
    const text = getValue({ isMultiSelect, multiSelectTitle, titleKey, value })

    return (
      <div
        className={classNames(styles.trigger, styles[size], styles[type], triggerClassName, {
          [styles.open]: isOpen,
          [styles.error]: !!error || !isValid,
          [styles.disabled]: isDisabled,
        })}
        onClick={!isDisabled ? handlePopoverToggle : () => {}}>
        <div className={styles.value}>
          {type === 'secondary' && size === 'regular' ? (
            <Text size={18} lineHeight={1.11} weight="bold" display="block">
              {text ? text : placeholder}
            </Text>
          ) : (
            <Text>{text ? text : placeholder}</Text>
          )}
        </div>

        <div className={styles.arrow}>
          <ArrowIcon className={styles.icon} />
        </div>
      </div>
    )
  }

DefaultTriggerRenderer.propTypes = {
  // dropdown
  handlePopoverToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,

  // own
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isValid: PropTypes.bool,
  multiSelectTitle: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(LIST_SIZES),
  selectedItems: PropTypes.array,
  titleKey: PropTypes.string,
  type: PropTypes.oneOf(LIST_TYPES),
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  triggerClassName: PropTypes.string,
}
